import {useState,useEffect} from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact Us' },
];

const Header = () => {
  const location = useLocation();
  const [isVerySmall, setIsVerySmall] = useState(window.innerWidth < 300);
  
  useEffect(() => {
      const handleResize = () => setIsVerySmall(window.innerWidth < 300);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header
     className={`flex flex-col sm:flex-row items-center sm:justify-between bg-white shadow px-4 py-3 mb-6 rounded-lg space-y-2 sm:space-y-0 ${
        isVerySmall ? 'overflow-x-auto whitespace-nowrap' : ''
      }`}>
      {/* Logo/Icon */}
      <Link to="/" className="flex items-center space-x-2 mb-2 sm:mb-0">
        <span className="text-orange-500 text-2xl">
          {/* Ladakh-style mountains with sun SVG */}
          <svg className="w-8 h-8" viewBox="0 0 32 32" fill="none">
            {/* Sun */}
            <circle cx="25" cy="8" r="4" fill="#FDB813" />
            {/* Mountains */}
            <polygon points="2,28 10,16 18,28" fill="#A3B18A" stroke="#6B705C" strokeWidth="1"/>
            <polygon points="12,28 20,20 30,28" fill="#6B705C" stroke="#6B705C" strokeWidth="1"/>
            {/* Snow caps */}
            <polyline points="10,16 12,20 14,18 16,22 18,18" fill="none" stroke="#fff" strokeWidth="1"/>
            <polyline points="20,20 22,24 24,22 26,26 28,24" fill="none" stroke="#fff" strokeWidth="1"/>
            {/* Ground */}
            <rect x="2" y="28" width="28" height="2" fill="#B7B7A4"/>
          </svg>
        </span>
        <span className="font-bold text-xl text-orange-600">Tour Leh Ladakh</span>
      </Link>
      {/* Navigation */}
      <nav className="flex flex-row sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
        {navLinks.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`px-3 py-1.5 rounded-md font-medium transition-colors ${
              location.pathname === link.to
                ? 'bg-orange-500 text-white'
                : 'text-gray-700 hover:bg-orange-100'
            }`}
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </header>
  );
};

export default Header;